// frontend/src/App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage      from "./pages/LoginPage";
import Dashboard      from "./pages/Dashboard";
import MapPage        from "./pages/MapPage";
import ReportsPage    from "./pages/ReportsPage";
import CollectPage    from "./pages/CollectPage";
import AdminDashboard from "./pages/admin/AdminDashboard";

function PrivateRoute({ children }) {
  return localStorage.getItem("token") ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!localStorage.getItem("token")) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function CollectRoute({ children }) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!localStorage.getItem("token")) return <Navigate to="/login" replace />;
  if (!["admin","supervisor"].includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login"     element={<LoginPage />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/"          element={<PrivateRoute><MapPage /></PrivateRoute>} />
        <Route path="/reports"   element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
        <Route path="/collect"   element={<CollectRoute><CollectPage /></CollectRoute>} />
        <Route path="/admin"     element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="*"          element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
